export default "__VITE_ASSET__0954e3fe__"